// extracted by mini-css-extract-plugin
module.exports = {"contentCapcalera":"capcaleraGrafic_contentCapcalera__f4vP1","titol":"capcaleraGrafic_titol__dnnX4"};